import { useMemo } from "react";
import { BULK_SELECT_COL_ID, ACTIONS_COL_ID, ATTRIBUTE_STATUS } from "components/common/EntityDataTable/Constants";
const getVisibleAttributeColumns = (defaultDisplayedColumns, userColumnPreferences = {}) => {
  const userSelection = new Set(
    Object.entries(userColumnPreferences).filter(([, { status }]) => status === ATTRIBUTE_STATUS.show).map(([attr]) => attr)
  );
  if (userSelection.size > 0) {
    return userSelection;
  }
  return new Set(defaultDisplayedColumns);
};
const useVisibleColumnOrder = (columnPreferences, attributeColumnOrder, defaultDisplayedColumns, displayBulkSelectCol) => useMemo(() => {
  const visibleAttributeColumns = getVisibleAttributeColumns(defaultDisplayedColumns, columnPreferences);
  const coreOrder = attributeColumnOrder.filter((id) => visibleAttributeColumns.has(id));
  const additionalVisible = [...visibleAttributeColumns].filter((id) => !attributeColumnOrder.includes(id));
  return [...displayBulkSelectCol ? [BULK_SELECT_COL_ID] : [], ...coreOrder, ...additionalVisible, ACTIONS_COL_ID];
}, [columnPreferences, defaultDisplayedColumns, attributeColumnOrder, displayBulkSelectCol]);
export default useVisibleColumnOrder;
